import clsx from "clsx";
import { GradientButton } from "components/GradientButton";
import { routesEnum } from "pages/Routes";
import { FC } from "react";
import { Link } from "react-router-dom";
import styles from "./styles.module.css";

const CardBuild: FC = () => {
  return (
    <div className={clsx(styles.cardBuild, styles.card)}>
      <img src="/images/landing/build_icon.svg" />
      <h3>Buidl</h3>
      <p>
        Create or joins Projects, Find mentors, validate ideas & even get
        investor support
      </p>
      <Link to={routesEnum.software}>
        <GradientButton color="secondary">Explore Projects</GradientButton>
      </Link>
    </div>
  );
};

export default CardBuild;
